import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDownIcon, PhoneIcon } from 'lucide-react';
import { Button } from './Button';
const serviceColumns = [{
  title: 'Primary Mortgages',
  links: [{
    to: '/services/private-mortgages',
    label: 'Private Mortgages'
  }, {
    to: '/services/residential-mortgage',
    label: 'Residential Mortgage'
  }, {
    to: '/services/commercial-mortgage',
    label: 'Commercial Mortgage'
  }, {
    to: '/services/bridge-mortgage',
    label: 'Bridge Mortgage'
  }, {
    to: '/services/self-employed-mortgage',
    label: 'Self-Employed Mortgage'
  }, {
    to: '/services/no-income-mortgages',
    label: 'No Income Mortgages'
  }]
}, {
  title: 'Equity Products',
  links: [{
    to: '/services/home-equity-loans',
    label: 'Home Equity Loans'
  }, {
    to: '/services/heloc',
    label: 'HELOC'
  }, {
    to: '/services/second-mortgages',
    label: 'Second Mortgages'
  }, {
    to: '/services/reverse-mortgages',
    label: 'Reverse Mortgages'
  }, {
    to: '/services/property-investment-mortgage',
    label: 'Property Investment Mortgage'
  }]
}, {
  title: 'Specialized Solutions',
  links: [{
    to: '/services/secondary-suite-mortgage',
    label: 'Secondary Suite Mortgage'
  }, {
    to: '/services/interest-only-mortgage',
    label: 'Interest-Only Mortgage'
  }, {
    to: '/services/alternative-mortgage-lenders',
    label: 'Alternative Mortgage Lenders'
  }, {
    to: '/services/debt-consolidation-mortgage',
    label: 'Debt Consolidation Mortgage'
  }, {
    to: '/services/retirement-mortgage',
    label: 'Retirement Mortgage'
  }, {
    to: '/services/spousal-buyout-mortgage',
    label: 'Spousal Buyout Mortgage'
  }]
}];
const locationColumns = [{
  title: 'Greater Toronto Area',
  links: [{
    to: '/locations/toronto',
    label: 'Toronto'
  }, {
    to: '/locations/mississauga',
    label: 'Mississauga'
  }, {
    to: '/locations/brampton',
    label: 'Brampton'
  }, {
    to: '/locations/markham',
    label: 'Markham'
  }]
}, {
  title: 'Surrounding Regions',
  links: [{
    to: '/locations/vaughan',
    label: 'Vaughan'
  }, {
    to: '/locations/richmond-hill',
    label: 'Richmond Hill'
  }, {
    to: '/locations/oakville',
    label: 'Oakville'
  }, {
    to: '/locations/burlington',
    label: 'Burlington'
  }]
}];
export function Header() {
  const [servicesOpen, setServicesOpen] = useState(false);
  const [locationsOpen, setLocationsOpen] = useState(false);
  return <header className="sticky top-0 z-50 w-full bg-[#fefefe] shadow-md px-4" data-id="element-181">
      <div className="max-w-7xl mx-auto" data-id="element-182">
        <div className="flex items-center justify-between h-20" data-id="element-183">
          {/* Logo */}
          <Link to="/" className="flex items-center hover:opacity-90 transition-opacity" data-id="element-184">
            <img src="https://cdn.magicpatterns.com/uploads/fGLyk5eN85HLF7UJKwRUox/White_logo.png" alt="EquityRich" className="h-10 w-auto" style={{
            filter: 'brightness(0) saturate(100%) invert(20%) sepia(30%) saturate(1500%) hue-rotate(120deg) brightness(0.7)'
          }} data-id="element-185" />
          </Link>

          {/* Navigation */}
          <nav className="hidden lg:flex items-center space-x-8" aria-label="Main navigation" data-id="element-186">
            <Link to="/" className="text-[#404040] hover:text-primary font-medium transition-colors" data-id="element-187">
              Home
            </Link>

            {/* Services - Mega Menu Trigger */}
            <div className="h-20 flex items-center -my-10" onMouseEnter={() => {
            setServicesOpen(true);
            setLocationsOpen(false);
          }} onMouseLeave={() => setServicesOpen(false)} data-id="element-188">
              <Link to="/services" className="flex items-center text-[#404040] hover:text-primary font-medium transition-colors" aria-expanded={servicesOpen} aria-haspopup="true" data-id="element-189">
                Services
                <ChevronDownIcon className="ml-1 h-4 w-4" aria-hidden="true" data-id="element-190" />
              </Link>
            </div>

            {/* Locations - Mega Menu Trigger */}
            <div className="h-20 flex items-center -my-10" onMouseEnter={() => {
            setLocationsOpen(true);
            setServicesOpen(false);
          }} onMouseLeave={() => setLocationsOpen(false)} data-id="element-191">
              <button className="flex items-center text-[#404040] hover:text-primary font-medium transition-colors" aria-expanded={locationsOpen} aria-haspopup="true" data-id="element-192">
                Locations
                <ChevronDownIcon className="ml-1 h-4 w-4" aria-hidden="true" data-id="element-193" />
              </button>
            </div>

            <Link to="/blog" className="text-[#404040] hover:text-primary font-medium transition-colors" data-id="element-194">
              Blog
            </Link>

            <Link to="/contact" className="text-[#404040] hover:text-primary font-medium transition-colors" data-id="element-195">
              Contact
            </Link>
          </nav>

          {/* CTA Buttons */}
          <div className="hidden lg:flex items-center space-x-4" data-id="element-196">
            <a href="tel:+16476679957" className="flex items-center text-[#404040] hover:text-primary font-medium transition-colors" data-id="element-197">
              <PhoneIcon className="h-5 w-5 mr-2" aria-hidden="true" data-id="element-198" />
              <span className="text-sm" data-id="element-199">+1-647-667-9957</span>
            </a>
            <Button variant="primary" size="md" href="/#form" data-id="element-200">
              Apply Now
            </Button>
          </div>
        </div>
      </div>

      {/* Services Mega Menu - Full width, below entire header */}
      {servicesOpen && <div className="absolute left-0 right-0 top-full bg-white border-t border-gray-100 shadow-xl z-50" onMouseEnter={() => setServicesOpen(true)} onMouseLeave={() => setServicesOpen(false)} data-id="element-201">
          <div className="absolute left-0 right-0 -top-2 h-2" data-id="element-202" />
          <div className="max-w-7xl mx-auto px-4 py-8" data-id="element-203">
            <div className="grid grid-cols-3 gap-10" data-id="element-204">
              {serviceColumns.map(column => <div key={column.title} data-id="element-205">
                  <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-4 font-[Poppins,_sans-serif]" data-id="element-206">
                    {column.title}
                  </h3>
                  <ul className="space-y-1" data-id="element-207">
                    {column.links.map(link => <li key={link.to} data-id="element-208">
                        <Link to={link.to} className="block px-3 py-2 text-sm text-gray-700 hover:bg-cream hover:text-primary rounded-lg transition-colors" data-id="element-209">
                          {link.label}
                        </Link>
                      </li>)}
                  </ul>
                </div>)}
            </div>
            <div className="mt-6 pt-6 border-t border-gray-100 flex items-center justify-between" data-id="element-210">
              <p className="text-sm text-gray-500" data-id="element-211">
                Not sure which option is right for you?
              </p>
              <Button variant="primary" size="sm" href="/contact" data-id="element-212">
                Get Free Advice
              </Button>
            </div>
          </div>
        </div>}

      {/* Locations Mega Menu - Full width, below entire header */}
      {locationsOpen && <div className="absolute left-0 right-0 top-full bg-white border-t border-gray-100 shadow-xl z-50" onMouseEnter={() => setLocationsOpen(true)} onMouseLeave={() => setLocationsOpen(false)} data-id="element-213">
          <div className="absolute left-0 right-0 -top-2 h-2" data-id="element-214" />
          <div className="max-w-7xl mx-auto px-4 py-8" data-id="element-215">
            <div className="grid grid-cols-2 gap-10 max-w-2xl" data-id="element-216">
              {locationColumns.map(column => <div key={column.title} data-id="element-217">
                  <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-4 font-[Poppins,_sans-serif]" data-id="element-218">
                    {column.title}
                  </h3>
                  <ul className="space-y-1" data-id="element-219">
                    {column.links.map(link => <li key={link.to} data-id="element-220">
                        <Link to={link.to} className="block px-3 py-2 text-sm text-gray-700 hover:bg-cream hover:text-primary rounded-lg transition-colors" data-id="element-221">
                          {link.label}
                        </Link>
                      </li>)}
                  </ul>
                </div>)}
            </div>
            <div className="mt-6 pt-6 border-t border-gray-100 flex items-center justify-between" data-id="element-222">
              <p className="text-sm text-gray-500" data-id="element-223">
                We serve homeowners across the Greater Toronto Area.
              </p>
              <Button variant="primary" size="sm" href="/contact" data-id="element-224">
                Find Your Location
              </Button>
            </div>
          </div>
        </div>}
    </header>;
}